<div class="layout-wrapper layout-content-navbar bg-white">
  <div class="layout-container">
    <app-side-nav></app-side-nav>

    <div class="container-fluid py-3">
      <!-- Header -->
      <div class="row align-items-center mb-4">
        <div class="col-md-8 col-12 text-md-start text-center">
          <h4 class="users-heading">
            <span class="text-muted fw-light">User Management /</span> Users List
          </h4>
        </div>
        <div class="col-md-4 col-12 text-md-end text-center mt-3 mt-md-0">
          <button class="btn custom-button" (click)="openAddUserModal()">
            + Add User
          </button>
        </div>
      </div>

      <!-- Filters -->
      <div class="row gy-3 align-items-end filter-row mb-3">

        <!-- Search Input -->
        <div class="col-md-4 col-sm-6 col-12">
          <input
            type="text"
            placeholder="Search by name, mobile"
            [(ngModel)]="searchText"
            class="form-control"
            (keydown.enter)="searchUsers()"
          />
        </div>

        <!-- Designation -->
        <div class="col-md-3 col-sm-6 col-12">
          <select [(ngModel)]="designationFilter" class="form-select cursor-pointer">
            <option value="" disabled selected hidden>
              Filter Designation
            </option>
            <option value="CRO">CRO</option>
            <option value="CRC">CRC</option>
            <option value="PI">PI</option>
            <option value="Monitor">Monitor</option>
          </select>
        </div>

        <!-- Status -->
        <div class="col-md-3 col-sm-6 col-12">
          <select [(ngModel)]="statusFilter" class="form-select cursor-pointer">
            <option value="" disabled selected hidden>Filter By Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <!-- Buttons -->
        <div class="col-md-2 col-sm-6 col-12 d-flex gap-2 justify-content-center">
          <button class="btn custom-button px-4" (click)="searchUsers()">Search</button>
          <button class="btn custom-button px-3" (click)="clear()">Clear</button>
        </div>
      </div>

      <!-- Spinner -->
      <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height:150px;">
        <div class="spinner-border text-purple" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Table -->
      <div class="card mt-3" *ngIf="!loading">
        <div class="table-responsive rounded">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile No</th>
                <th>Email-ID</th>
                <th>Designation</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of filteredData">
                <td>{{ user.name }}</td>
                <td>{{ user.mobile }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.designation }}</td>
                <td>
                  <span class="badge bg-label-primary">{{ user.status }}</span>
                </td>
                <td>
                  <div class="dropdown">
                    <button
                      class="btn p-0 dropdown-toggle hide-arrow"
                      data-bs-toggle="dropdown"
                    >
                      <i class="bx bx-dots-vertical-rounded"></i>
                    </button>

                    <ul class="dropdown-menu dropdown-menu-end custom-dropdown-menu">
                      <li>
                        <a class="dropdown-item cursor-pointer" (click)="openEditUserModal(user)">
                          <i class="bx bx-edit-alt me-1"></i> Edit
                        </a>
                      </li>
                      <li>
                        <a 
                          class="dropdown-item cursor-pointer" 
                          [class.disabled]="isCurrentUser(user) && user.status === 'Active'"
                          [style.pointer-events]="isCurrentUser(user) && user.status === 'Active' ? 'none' : 'auto'"
                          [style.opacity]="isCurrentUser(user) && user.status === 'Active' ? '0.5' : '1'"
                          (click)="toggleUserStatus(user)"
                          [title]="isCurrentUser(user) && user.status === 'Active' ? 'You cannot inactivate your own account' : ''"
                        >
                          <i
                            class="bx"
                            [ngClass]="{
                              'bx-user-x': user.status === 'Active',
                              'bx-user-check': user.status === 'Inactive'
                            }"
                          ></i>
                          {{ user.status === 'Active' ? 'Inactive' : 'Active' }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-4">
        <div class="col text-center">
          <nav aria-label="Page navigation">
            <ul class="pagination justify-content-center flex-wrap">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="prevPage()">Previous</a>
              </li>

              <li
                *ngFor="let page of pageRange"
                class="page-item"
                [class.active]="page === currentPage"
              >
                <a class="page-link mx-2" (click)="goToPage(page)">{{ page }}</a>
              </li>

              <li class="page-item" [class.disabled]="currentPage === pages">
                <a class="page-link" (click)="nextPage()">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add User Modal -->
<div class="modal fade" id="addUserModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add User</h5>
      </div>
      <div class="modal-body">
        <app-add-user
          (userAddedEvent)="onUserAdded()"
          (closeFormEvent)="onUserAdded()"
        ></app-add-user>
      </div>
    </div>
  </div>
</div>

<!-- Edit User Modal -->
<div class="modal fade" id="editUserModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit User</h5>
      </div>
      <div class="modal-body">
        <app-edit-user
          [userId]="selectedUserId"
          (userUpdatedEvent)="onUserUpdated()"
          (closeFormEvent)="onUserUpdated()"
        ></app-edit-user>
      </div>
    </div>
  </div>
</div>
